const getWidgetSelf = (theapp, widget_uuid) => {
	var self = theapp.getVariable(widget_uuid) ;

	if (self)
		return self;

	self = {};

	theapp.setVariable(widget_uuid, self);

	return self;
}

export default getWidgetSelf;